import {z} from 'zod'

import {CreateOrUpdateBlockMediaComparisonSliderDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockMediaComparisonSliderInput, CreateOrUpdateBlockMediaComparisonSliderMutation} from '@sdox/api'

export type UpdateComparisonSliderValidatorSchema = z.infer<typeof updateComparisonSliderValidatorSchema>

const updateComparisonSliderValidatorSchema = z.object({
  data: z.object({
    image1: z.object({
      fileHash: z.string().min(1),
    }),
    image2: z.object({
      fileHash: z.string().min(1),
    }),
  }),
  meta: updateMetaSchema,
})

export const comparisonSliderConfig = createFormConfig<
  UpdateComparisonSliderValidatorSchema,
  CreateOrUpdateBlockMediaComparisonSliderMutation,
  BlockMediaComparisonSliderInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockMediaComparisonSliderDocument,
  },
  fieldMapper: (fieldValues) => ({
    fileHash1: fieldValues.data.image1.fileHash,
    fileHash2: fieldValues.data.image2.fileHash,
  }),
  validatorSchema: updateComparisonSliderValidatorSchema,
  inputFields: [
    {
      label: 'Linkes Bild',
      fieldName: 'data.image1',
      inputType: 'image',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Rechtes Bild ',
      fieldName: 'data.image2',
      inputType: 'image',
      defaultValue: '',
      required: true,
    },
  ],
})
